<template>
  <div >
    <span :class="claseError">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>
  
      <v-autocomplete
        class="mt-1"
        v-model="valor"
        :items="itemsData"
        item-text="texto"
        item-value="id"
        :placeholder="Mensaje"
        :loading="loadSelect"
        :disabled="bEditable"
        height="30px"
        clearable
        outlined
        dense
        :error="esError"
        :rules="noVacio"
        :alt="'cmp-select-'+altValue"
        hide-details
        >
        <template slot="no-data">
          <div>No hay información</div>
        </template>
      </v-autocomplete>
  </div>
  </template>
  
  <script>
  import axiosServices from "@/services/axiosServices.js"
  import FormMixin from '@/mixins/formularioMixin.js'
  import { mapGetters } from 'vuex'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
  
  export default {
    name: 'FormSelect',
    mixins: [FormMixin],
    components: {
      IconoInformacion,
    },
    props: {
      inner:{
        type: String,
        default: ''
      },
      condicion:{
        type: String,
        default: ''
      },
      altValue:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        valor           : this.value,
        itemsData       : [],
        loadSelect      : false,
        Mensaje         : 'Cargando..',
        esError         : false,
        noVacio         : [v => !!v],
        bEditable       : (this.editable == "0") ? true : false,
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      getItems(){
        let sParams = this.onExtraerParametros()
        if(this.condicion != null && this.condicion != ""){
          sParams = sParams + "&condicion=" + this.condicion.replaceAll('&&','%%')
        }
  
        if(this.bSubdominioTemporal) sParams += `&subdominiot=${this.$store.state.sSubdominioTemporal}`
        let sAux = this.inner != null ? this.inner.split(',') : '' 
        this.loadSelect = true
        this.Mensaje = 'Cargando ..'
        axiosServices.getConfiguration('/select/' + sAux[0] + '/' + this.campo , true, sParams ).then(aItems =>{
          this.itemsData = aItems.aData
          this.loadSelect = false
          this.Mensaje = 'Seleccione ' + this.titulo
        })
      },
    },
    computed: {
      ...mapGetters(['getoFormError'])
    },
    watch: {
      valor(NewValor){
        this.$emit('selectTexto', this.itemsData.find( elemento => elemento.id == NewValor) != undefined ? this.itemsData.find( elemento => elemento.id == NewValor).texto : '')
      },
      value(){
        this.valor=this.value;
      }
    },
    
  }
  </script>
  
  <style scoped>
  
  
  </style>